import styled from 'styled-components';

export const Container = styled.div<{ isMobile?: boolean }>({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '24px',
  minHeight: '340px',
});
